/**
 * Os fusos que uma organização brasileira usa, com o nome da cidade na frente.
 *
 * Uma lista curta, e não `Intl.supportedValuesOf('timeZone')` com seiscentos
 * itens: quem cria uma organização escolhe entre estes, e uma caixa com
 * "Africa/Abidjan" no topo é onde se erra por rolagem. O servidor valida o
 * fuso de qualquer jeito; a lista é conveniência, e não regra.
 *
 * Os mesmos doze das Configurações. As Configurações e as Automações ainda têm
 * a lista delas; passar as duas para esta é um PR à parte.
 */
export const FUSOS_DO_BRASIL: readonly { readonly valor: string; readonly rotulo: string }[] = [
  { valor: 'America/Sao_Paulo', rotulo: 'Brasília (America/Sao_Paulo)' },
  { valor: 'America/Bahia', rotulo: 'Salvador (America/Bahia)' },
  { valor: 'America/Fortaleza', rotulo: 'Fortaleza (America/Fortaleza)' },
  { valor: 'America/Recife', rotulo: 'Recife (America/Recife)' },
  { valor: 'America/Belem', rotulo: 'Belém (America/Belem)' },
  { valor: 'America/Manaus', rotulo: 'Manaus (America/Manaus)' },
  { valor: 'America/Cuiaba', rotulo: 'Cuiabá (America/Cuiaba)' },
  { valor: 'America/Campo_Grande', rotulo: 'Campo Grande (America/Campo_Grande)' },
  { valor: 'America/Porto_Velho', rotulo: 'Porto Velho (America/Porto_Velho)' },
  { valor: 'America/Boa_Vista', rotulo: 'Boa Vista (America/Boa_Vista)' },
  { valor: 'America/Rio_Branco', rotulo: 'Rio Branco (America/Rio_Branco)' },
  { valor: 'America/Noronha', rotulo: 'Fernando de Noronha (America/Noronha)' },
];
